module.exports = __webpack_public_path__ + "static/media/home-01.af537e0e.webp";